import * as React from "react";
import { forwardRef } from "react";
const SvgActivateIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 13, viewBox: "0 0 11 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.83333 5.16673V0.500061L0.5 7.83339H4.5V12.5001L9.83333 5.16673H5.83333Z", stroke: "#FBFDFF", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgActivateIcon);
export default ForwardRef;
